import { LIFECYCLE_STATUS } from "../types/common";

export interface SystemFailureNotice {
  title: string;
  reason: string;
}

/**
 * Banner for a system-set `system_rejection_reason` (VIP writes it only on
 * OCR_FAILED and D365_FAILED). D365 is internal-only: vendors see that state as "Approved".
 */
export function systemFailureNotice(
  status: string | null | undefined,
  reason: string | null | undefined,
  isInternal: boolean
): SystemFailureNotice | null {
  const text = reason?.trim();
  if (!text) return null;
  if (status === LIFECYCLE_STATUS.OCR_FAILED) {
    return { title: "Could not process this invoice", reason: text };
  }
  if (status === LIFECYCLE_STATUS.D365_FAILED && isInternal) {
    return { title: "ERP upload failed", reason: text };
  }
  return null;
}
